import { Controller } from "@hotwired/stimulus"

// Flags sessionStorage right before the "Sair" button's request fires, so
// splash_controller knows the next time it connects on the sign-in page is
// a genuine post-logout landing (splash should replay) rather than just
// bouncing between sign-in/sign-up/forgot-password (splash should not).
export default class extends Controller {
  mark() {
    sessionStorage.setItem("lifJustLoggedOut", "1")
  }
}
